import React, { FC } from 'react';

import CardIssuerLogo from 'Jsx/Shared/CardIssuerLogo';
import { CustomerCard } from 'Jsx/CheckoutV4/types';

type SavedCardItemProps = {
  card: CustomerCard;
  handleSelectSavedCard: () => void;
  isSelected: boolean;
};

const SavedCardItem: FC<SavedCardItemProps> = ({
  card,
  handleSelectSavedCard,
  isSelected,
}) => {
  return (
    <button
      type="button"
      className={`w-full flex items-center mt-16 p-20 md:p-24 ${
        isSelected ? 'bg-gray-lighter' : 'bg-white cursor-pointer'
      }`}
      style={{
        border: '1px solid #DFE1E6',
        boxShadow: isSelected ? '0px 2px 6px rgba(92, 84, 122, 0.2)' : 'none',
      }}
      onClick={handleSelectSavedCard}
      onKeyDown={handleSelectSavedCard}
    >
      <div
        className="flex-shrink-0 p-4 mr-8 rounded-full"
        style={{
          border: isSelected ? '1px solid #4B22F4' : '1px solid #DFE1E6',
          width: 20,
          height: 20,
        }}
      >
        {isSelected && (
          <div
            className="rounded-full bg-purple-main"
            style={{ width: 10, height: 10 }}
          />
        )}
      </div>
      <div
        className="flex justify-center align-center flex-shrink-0"
        style={{ width: 50 }}
      >
        <CardIssuerLogo cardType={card?.cardBrand || ''} />
      </div>
      <span className="ml-auto font-subtitle4" style={{ letterSpacing: '2px' }}>
        <span className="text-11 md:text-14">●●●● ●●●● ●●●●</span>{' '}
        {card?.cardNumber}
      </span>
    </button>
  );
};

export default SavedCardItem;
